module.exports = __webpack_public_path__ + "assets/6fc5a0f39653e891e6fa199d357f535a.svg";